function ThirdPillarOffer() {
  let calculator = new Calculator2021(CalculatorConfiguration, fundShares)
  let self = this

  self.init = function () {
    const animation = new Animation();
    let paymentAmountSlider = $('#paymentAmountSlider')

    if (paymentAmountSlider.length > 0) {
      const amountSlider = paymentAmountSlider.slider()

      amountSlider.on('slide slideStop', sliderEvent.bind(this))
      amountSlider.on('slideStop', function () {
        animation.pulseAmount($('#thirdPillarReceivedAmountDisplay'))
      })
    }
  }

  function sliderEvent(slideEvt) {
    let sliderValue = slideEvt.value
    $('#paymentAmountDisplay').html(sliderValue)
    $('#thirdPillarReceivedAmountDisplay').html(calculator.calculate(window.session.pension, sliderValue).total.toFixed(2))
  }
}